import type { WaterDensityPwCalculator } from "../d";
export const waterDensityPwCalculator: WaterDensityPwCalculator = params => {
  const { waterSpecificGravity, waterVolumeFactorBBLSTB } = params;

  // N28: =(62.4*C10)/H8
  const waterDensityLBMFT3 =
    (62.4 * waterSpecificGravity) / waterVolumeFactorBBLSTB;

  return {
    waterDensityLBMFT3
  };
};
